import { useEffect } from "react";
import { benefitsHeroBannerV3 } from "@/assets/images";
import { Button, ButtonType } from "@/components/common/button";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { v4 as uuid } from "uuid";

const BenefitsCompareBanner = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  return (
    <>
      <p className="section-title mb-4">
        Are you ready to lose weight safely & quickly?
      </p>

      <img src={benefitsHeroBannerV3} alt="SkinnyRx benefits" />

      <Button onClick={() => setQuestionAnswer(true)} type={ButtonType.NEXT} />
    </>
  );
};

export { BenefitsCompareBanner };
